import { BloczekMarker } from '~/components/map/types/marker/BloczekMarker';
import IMarkerInfo from '~/components/map/types/marker/IMarkerInfo';

import IGoogleMapPosition from '../../../types/IGoogleMapPosition';
import centerMapByMarkerCoords from '../../shared/centerMapByMarkerCoords';
import setActiveMarker from '../../shared/setActiveMarker';
import getMarkerPosition from './getMarkerPosition';

const markerClicked = ({ marker, activeMarker, mapRef }: IMarkerInfo<BloczekMarker>) => {
  const position: IGoogleMapPosition = getMarkerPosition(marker);

  centerMapByMarkerCoords({
    position,
    mapRef,
  });
  setActiveMarker(activeMarker, marker);
};
export default markerClicked;
